export const plansMap = new Map([
    ['mtn-ng-daily', '-MNteIjb159_RO40dUaC'],
    ['mtn-gh-daily', '-MKNpplPjGNq2PUbrNBV'],
    ['gh-yearly', '-NJtGdYgNGt1oGXc_PY3'],
]);
